module.exports = __webpack_public_path__ + "img/S LOMBA.9dab70c0.jpeg";